import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Camera, Clapperboard, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";

const SEEN_KEY = "whats_new_seen_v1"; // bump the suffix for future launches

// One-time "What's new" splash for returning families: real-child mouth
// videos + the family recording booth. Shows once per browser.
export const WhatsNewSplash = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    try {
      if (!localStorage.getItem(SEEN_KEY)) setOpen(true);
    } catch { /* private mode: skip the splash */ }
  }, []);
  const dismiss = () => {
    try { localStorage.setItem(SEEN_KEY, "1"); } catch { /* ok */ }
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && dismiss()}>
      <DialogContent className="max-w-md" data-testid="whats-new-splash">
        <DialogTitle className="flex items-center gap-2 text-lg font-extrabold font-display">
          <Sparkles className="h-5 w-5 text-amber-500" aria-hidden="true" /> What&apos;s new
        </DialogTitle>
        <DialogDescription className="sr-only">
          New features: real mouth videos for every sound and a family recording booth.
        </DialogDescription>
        <div className="space-y-3 text-left">
          <div className="flex gap-3 rounded-xl border border-border bg-background/60 p-3">
            <Clapperboard className="h-6 w-6 shrink-0 text-violet-500" aria-hidden="true" />
            <div>
              <p className="text-sm font-extrabold">Real mouth videos for every sound</p>
              <p className="text-xs text-muted-foreground">
                All 58 sounds now show a real child&apos;s mouth — synced to Pip&apos;s voice, with a Slow button for careful study.
              </p>
            </div>
          </div>
          <div className="flex gap-3 rounded-xl border border-border bg-background/60 p-3">
            <Camera className="h-6 w-6 shrink-0 text-emerald-500" aria-hidden="true" />
            <div>
              <p className="text-sm font-extrabold">Family recording booth</p>
              <p className="text-xs text-muted-foreground">
                Record YOUR mouth modeling a sound during practice — your child mirrors a familiar face, and clips live in your new Family Video Library below.
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={dismiss} data-testid="whats-new-dismiss">
            Got it
          </Button>
          <Button onClick={() => { dismiss(); navigate("/dashboard#family-video-library"); }}
            className="bg-violet-600 hover:bg-violet-700" data-testid="whats-new-cta">
            See the library
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
